import React, { Fragment, useMemo } from "react";
import jsonLexer from "json-lexer";
import { Box, useTheme } from "@mui/material";
import { green, lightBlue, orange, purple } from "@mui/material/colors";
const COLORS = {
    literal: orange,
    number: lightBlue,
    string: green,
    key: purple,
};
export function Json({ data }) {
    const tokens = useMemo(() => {
        const jsonString = JSON.stringify(data, null, 4);
        return detectKeys(jsonLexer(jsonString));
    }, [data]);
    const theme = useTheme();
    const shade = theme.palette.mode == "light" ? 700 : 300;
    return (React.createElement(Fragment, null, tokens.map(({ type, value, raw }) => {
        switch (type) {
            case "punctuator": return raw;
            case "whitespace": return raw;
            case "literal": return React.createElement(Box, { component: "span", color: COLORS.literal[shade] }, raw);
            case "number": return React.createElement(Box, { component: "span", color: COLORS.number[shade] }, raw);
            case "string": return React.createElement(Box, { component: "span", color: COLORS.string[shade] }, raw);
            case "key": return React.createElement(Box, { component: "span", color: COLORS.key[shade] }, value);
        }
    })));
}
function detectKeys(tokens) {
    const tree = [];
    let nextStringIsKey = false;
    return tokens.map(token => {
        if (token.type == "string" && nextStringIsKey) {
            return Object.assign(Object.assign({}, token), { type: "key" });
        }
        if (token.type == "punctuator") {
            switch (token.value) {
                case "{":
                    tree.push("object");
                    nextStringIsKey = true;
                    break;
                case "[":
                    tree.push("array");
                    break;
                case "}":
                case "]":
                    tree.pop();
                    nextStringIsKey = tree[tree.length - 1] == "object";
                    break;
                case ":":
                    nextStringIsKey = false;
                    break;
                case ",":
                    nextStringIsKey = tree[tree.length - 1] == "object";
                    break;
            }
        }
        return token;
    });
}
//# sourceMappingURL=Json.js.map